<cm-spinner [loading]="loading()" size="small">
  <neo-slide-toggle
    class="cm-switch"
    [class.cm-switch--space-between]="spaceBetweenLabelAndToggle()"
    [class.cm-switch--align-start]="alignStart()"
    [class.cm-switch--label-bold]="labelBold()"
    [checked]="effectiveChecked"
    [disabled]="effectiveDisabled"
    [color]="color()"
    [labelPosition]="labelPosition()"
    [required]="required()"
    [disableRipple]="disableRipple()"
    [autId]="autId()"
    [aria-label]="ariaLabel()"
    [aria-labelledby]="ariaLabelledby()"
    [aria-describedby]="ariaDescribedby()"
    [attr.id]="id()"
    [attr.name]="name()"
    (change)="onToggleChange($event.checked)"
  >
    <ng-content />
  </neo-slide-toggle>
</cm-spinner>
